<div class="container" *ngIf="!isPerfil">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h3 class="page-title text-center">Ocupaciones Asociadas al Motor | <b class="" [style]="{'color': motor.color }">{{motor.nombre}}</b></h3>
      </div>
    </div>
  </div>

  <img [src]="url + motor.iconos" alt="" class="icon" />

  <div class="row mt-4" style="margin-bottom: 500px;">

    <ng-container *ngFor="let oc of ocupacinesListi">

      <div class="col-md-3 mt-3 mb-3">
        <div class="card text-center h-100 shadow-lg" [style]="'border-color: '+ motor.color +''">
          <div class="card-header text-white" [style]="'background-color: '+ motor.color +''">
            <p class="card-title">{{oc.ocupacion}}</p>
          </div>
          <div class="card-body">
            <p class="card-text sinopsis" style="text-align: justify;">{{oc.sinopsis | slice:0:300}}...</p>
            <div class="row">
              <div class="col-md-8 text-start">
                <p class="subtitles2">
                  <b class="sinopsis" [style]="{'color': motor.color }">Ocupación Cualificada:</b>
                  {{oc.ocupacion}}
                </p>
              </div>
              <div class="col-md-4 mt-4 text-end">
                <p class="sinopsis hrs">{{oc.horas}} Hrs</p>
              </div>
            </div>

          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-md-6">
                <a class="btn btn-primary" [style]="'background: '+motor.color+' !important; border-color: '+motor.color+' !important;'" (click)="informacion(content, oc)">
                  Formaciones
                </a>
              </div>
              <div class="col-md-6">
                <a class="btn btn-secondary">
                  Inscribirme
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </ng-container>

  </div>


  <app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>

  <ng-template #content let-modal>
    <div class="modal-header text-white" [style]="'background-color: '+ motor.color +''">
      <h4 class="modal-title">{{nombre_ocupacion}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-8 h4 text-center" [style]="'color: '+ motor.color +''">Plan de Estudio (PPL)</div>
        <div class="col-md-4 h4 text-center" [style]="'color: '+ motor.color +''">Horas </div>
        <hr [style]="'color: '+motor.color+'; height: 10px; background-color: '+motor.color+'; '">
        <div class="col-12" *ngFor="let pf of perfilesList, let i=index">
          <div class="form-check form-checkbox-info mb-2">
            <div class="row puntero" (click)="muestraPerfil(pf, motor.color, motor.iconos, motor.id_motor_productivo)">
              <div class="col-md-8 mt-1">{{pf.nombre_perfil}}</div>
              <div class="col-md-4 mt-1 text-center">{{pf.horas}} </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <a type="button" [style]="'background:'+motor.color+' !important; border-color:'+motor.color+' !important;'" class="btn btn-lg btn-secondary"
      (click)="modal.close('Close click')">
        Cerrar
      </a>
    </div>
  </ng-template>



</div>

<app-lista-perfil *ngIf="isPerfil"
[datos_perfil]="perfil"
[color]="color_env"
[iconos]="icono"
[idMotor]="id_motor"
(vuelve_2)="volver_2($event)"
></app-lista-perfil>

